<template>
  <div id="app">
    <!-- 页面缓存 -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    console.log('第一次进入的路由',window.location.href)

  },
  methods: {},
}
</script>

<style>
/* @media screen and (min-width: 769px) {
  #app {
    width: 750px;
    margin: 0 auto;
  }
} */
</style>
<style lang="less">
@import url(//at.alicdn.com/t/c/font_4085016_8iomvps6ye3.css);
#app {
  background-color: #f7f7fa;
  min-height: 100vh;
  // position: relative;
}
@import './assets/css/base.scss';
@import './assets/css/common.css';
</style>
